import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ContactType} from '../../types/contact/contact-type';
import {LocationRestService} from '../../services/location/location-rest.service';

@Component({
  selector: 'wsd-select-contact-type',
  templateUrl: './select-contact-type.component.html',
  styleUrls: ['./select-contact-type.component.css']
})
export class SelectContactTypeComponent implements OnInit, OnDestroy {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_CONTACT_TYPE.LABEL';

  @Input()
  placeholder: string = 'SELECT_CONTACT_TYPE.PLACEHOLDER';

  @Input()
  controlName: string = 'contactType';

  @Input()
  showLabel: boolean = true;

  @Input()
  showPlaceholder: boolean = true;

  @Input()
  includingPostAddress: boolean = true;

  @Output()
  onChange = new EventEmitter<any>();

  contactTypeItems: SelectItem[] = [];

  private translateSubscription: Subscription;

  constructor(private translate: TranslateService,
              private locationService: LocationRestService) {
  }

  ngOnInit() {
    this.initValues();
    this.translateSubscription = this.translate.onDefaultLangChange.subscribe(
      (lang: any) => this.initValues()
    );
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  private initValues() {
    if (!this.translate.getDefaultLang()) {
      return;
    }
    this.contactTypeItems = [];
    for (const item in ContactType) {
      if (isNaN(Number(item))) {
        this.contactTypeItems.push({
          label: this.translate.instant('CONTACT_TYPES.' + item),
          value: item
        });
      }
    }
    if (this.includingPostAddress) {
      this.locationService.getLocationTypes().subscribe(locationTypes => {
        locationTypes.forEach(type => {
          this.contactTypeItems.push({
            label: this.translate.instant('LOCATION_TYPES.' + type),
            value: type
          });
        });
      });
    }
  }

  changeDropdownValue() {
    this.onChange.emit();
  }
}
